import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { authervice } from 'src/app/shared/service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  /**
   *
   */
  constructor(private authervice:authervice,private router: Router) {
    

  }
  ngOnInit(): void {
     console.log("test app");
     debugger
     if(this.authervice.getRole()!='Admin'){
      console.log("Disconnect");
      this.router.navigate(['/auth/login']);

     }
  }
  title = 'multikart-backend';
}
